/**
 * plugins/router.ts
 *
 * Automatically included in `./src/main.ts`
 */
// Plugins
// Types
import { i18n } from '@/locale/initVueI18n.ts';
import { queryClient } from '@/plugins/queryClient.ts';
import router from '@/router/router.ts';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { createPinia } from 'pinia';
import piniaPluginPersistedState from 'pinia-plugin-persistedstate';
import ToastService from 'primevue/toastservice';
import type { App, Plugin } from 'vue';

type PluginDeclaration = { plugin: Plugin; config?: unknown[] };

const pinia = createPinia();
pinia.use(piniaPluginPersistedState);

const globalPlugins: PluginDeclaration[] = [
    { plugin: ToastService },
    { plugin: pinia },
    {
        plugin: VueQueryPlugin,
        config: [
            {
                queryClient,
            },
        ],
    },
    { plugin: i18n },
    { plugin: router },
];

export const registerPlugins = (app: App) => {
    globalPlugins.forEach(({ plugin, config }) => app.use(plugin, ...(config ?? [])));
};
